import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, renderSlot as _renderSlot, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-30cc2212"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "live_tab_txt" }
const _hoisted_2 = ["src"]

import { computed, withDefaults } from 'vue';

import { playing } from '@/assets';
type sizeType = 'lg' | 'sm' | 'xs';

// 预告 进行中的  结束 回放 视频 直播 白色
type mType = 'start' | 'playing' | 'end' | 'replay' | 'video' | 'live' | 'info';

/**
 * todo 当前示例参数
 * **/
// type:['视频','文档','音频','互动','多频道','多语','竖屏'],
// type modeType = 0 | 1 | 2 | 3 | 4 | 5 | 6;
// status:['预告','直播','结束','回放'],
// type statusType = 0 | 1 | 2 | 3;

interface ILiveTab {
  type?: mType;
  size?: sizeType;
  icon?: string;
  tabType?: 'mode' | 'status';
  statusType?: number;
  playing?: number;
}

export default /*#__PURE__*/_defineComponent({
  __name: 'LiveTab',
  props: {
    type: { default: 'video' },
    size: { default: 'sm' },
    icon: { default: 'play' },
    tabType: null,
    statusType: { default: 0 },
    playing: { default: 0 }
  },
  setup(__props: any) {

const props = __props as { type: mType, size: sizeType, icon: string, tabType?: 'mode' | 'status', statusType: number, playing: number };

const tabArr = {
  mode: [
    {
      title: '视频',
      icon: 'tab_type_play',
      className: 'tab_type_video',
    },
    {
      title: '文档',
      icon: 'tab_type_play',
      className: 'tab_type_video',
    },
    {
      title: '音频',
      icon: 'tab_type_play',
      className: 'tab_type_video',
    },
    {
      title: '互动',
      icon: 'tab_type_interact',
      className: 'tab_type_video',
    },
    {
      title: '多频道',
      icon: 'tab_type_channel',
      className: 'tab_type_video',
    },
    {
      title: '多语',
      icon: 'tab_mode_language',
      className: 'tab_type_video',
    },
    {
      title: '竖屏',
      icon: 'tab_type_mobile',
      className: 'tab_type_video',
    },
  ],

  status: [
    {
      title: '预告',
      icon: 'tab_type_start',
      className: 'tab_type_start',
    },
    {
      title: '直播',
      icon: 'tab_type_live',
      className: 'tab_type_live',
    },
    {
      title: '结束',
      icon: 'tab_type_end',
      className: 'tab_type_end',
    },
    {
      title: '回放',
      icon: 'tab_type_playback',
      className: 'tab_type_replay',
    },
  ],
};



const tabText = computed(() => {
  if (props.tabType) {
    return tabArr[props.tabType][props.statusType].title;
  } else {
    return '视频';
  }
});

const tabIcon = computed(() => {
  if (props.tabType === undefined) return '';
  if (props.tabType) {
    return tabArr[props.tabType][props.statusType].icon;
  } else {
    return 'tab_type_video';
  }
});

const typeClassName = computed(() => {
  if (props.tabType) {
    return tabArr[props.tabType][props.statusType].className;
  } else {
    switch (props.type) {
      // case 'start':
      //   return 'tab_type_start';
      // case 'playing':
      //   return 'tab_type_video';
      // case 'end':
      //   return 'tab_type_end';
      // case 'replay':
      //   return 'tab_type_replay';
      // case 'live':
      //   return 'tab_type_live';
      case 'info':
        return 'tab_type_info';
      default:
        return 'tab_type_video';
    }
  }
});

const isPlaying = computed(() => props.playing === 1);
const playingClass = computed(() => (isPlaying.value ? 'mrtitle' : ''));
const sizeClassName = computed(() => {
  // return props.size === 'sm' ? 'tab_size_sm' : 'tab_size_lg';
  switch (props.size) {
    case 'xs':
      return 'tab_size_xs';
    case 'sm':
      return 'tab_size_sm';
    default:
      return 'tab_size_lg';
  }
});

return (_ctx: any,_cache: any) => {
  const _component_svg_icon = _resolveComponent("svg-icon")!

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["live_tab", [_unref(sizeClassName), _unref(typeClassName), _unref(playingClass)]])
  }, [
    _createVNode(_component_svg_icon, {
      "icon-class": _unref(tabIcon) ? _unref(tabIcon) : props.icon
    }, null, 8, ["icon-class"]),
    _createElementVNode("span", _hoisted_1, [
      _renderSlot(_ctx.$slots, "default", {}, () => [
        _createTextVNode(_toDisplayString(_unref(tabText)), 1)
      ])
    ]),
    (_unref(isPlaying))
      ? (_openBlock(), _createElementBlock("div", {
          key: 0,
          class: _normalizeClass(["playing_box", _unref(sizeClassName)])
        }, [
          _createElementVNode("img", {
            src: _unref(playing),
            alt: "",
            class: "playing_img"
          }, null, 8, _hoisted_2)
        ], 2))
      : _createCommentVNode("", true)
  ], 2))
}
}

})